<!-- Content -->
@if ((trainingSharedFacade.isTraining$ | async) === false) {
  <medsurf-slider></medsurf-slider>
}
@if ((trainingSharedFacade.isTraining$ | async) === true) {
  <medsurf-training-slider></medsurf-training-slider>
}




